import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

type FileThumbnailTokens = {
  bg: string
  border: string
  name: string
  typeLabel: string
  focusRing: string
}

const tokens: Record<ColorScheme, FileThumbnailTokens> = {
  dark: {
    bg: 'bg.card-elevated',
    border: 'border.subtle',
    name: 'text.primary',
    typeLabel: 'text.secondary',
    focusRing: 'interactive.focus-ring',
  },
  light: {
    bg: 'light.bg.card-elevated',
    border: 'light.border.subtle',
    name: 'light.text.primary',
    typeLabel: 'light.text.secondary',
    focusRing: 'light.interactive.focus-ring',
  },
}

export const fileThumbnailContainerStyles = (
  colorScheme: ColorScheme,
  isClickable: boolean,
  width: string
): SystemStyleObject => ({
  alignItems: 'center',
  bg: tokens[colorScheme].bg,
  border: '1px solid',
  borderColor: tokens[colorScheme].border,
  borderRadius: '8px',
  color: tokens[colorScheme].name,
  cursor: isClickable ? 'pointer' : 'default',
  display: 'flex',
  h: '50px',
  maxW: '100%',
  minW: 0,
  p: '6px',
  w: width,
  _hover: { shadow: 'md' },
  _focusVisible: {
    outline: '2px solid',
    outlineColor: tokens[colorScheme].focusRing,
    outlineOffset: '2px',
  },
})

export const fileThumbnailPreviewImageStyles: SystemStyleObject = {
  borderRadius: '4px',
  flexShrink: 0,
  h: '20px',
  objectFit: 'cover',
  w: '20px',
}

export const fileThumbnailBodyStyles: SystemStyleObject = {
  flex: '1',
  ml: '8px',
  minW: 0,
  overflow: 'hidden',
}

export const fileThumbnailNameStyles: SystemStyleObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
}

export const fileThumbnailTypeLabelStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: tokens[colorScheme].typeLabel,
  fontSize: '10px',
})
